/**********************************************************
Fab button Modal: Button actions for view, edit and deleting
**********************************************************/
import CultivationModal from '../cult_modal';
import ChemicalApplicationDisplay from './chem_app_display';
import { deleteChemicalApplication } from '../../actions/chem_app_actions';
import { filterOldRecords } from '../../cult_utils';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
const $ = window.$;

const propTypes = {
  chem: PropTypes.object,
  application: PropTypes.object,
  chemicalList: PropTypes.array,
  solutions: PropTypes.array,
  employees: PropTypes.array,
  fields: PropTypes.array,
  deleteChemicalApplication: PropTypes.func
};

// It's Fabulous!
const FabModal = ({ chem, chemicalList, employees, user, deleteChemicalApplication,
  selectedApp, selectApplicationToView }) => {
  $(document).ready(function(){
    $('.tooltipped').tooltip();
    $(`#${chem.chemAppId}-delete`).modal();
  });
  return (
    <div>
      <ul className="btn-actions">
        <li className="action-btn-li">
          <a className="btn-floating green pointer modal-trigger tooltipped btn-squared" href={`#${chem.chemAppId}-view`}
            onClick={() => selectApplicationToView(chem)}  data-position="left" data-tooltip="View">
            <i className="material-icons">subject</i>
          </a>
        </li>
        { Object.keys(user).length === 0 ? ''
          : user.level >= 3 || user.positionTitle.match(/Cultivation/) ?
            <li className="action-btn-li">
              <a className={`btn-floating red pointer modal-trigger tooltipped btn-squared ${filterOldRecords(chem) ? '' : 'disabled'}`} href={`#${chem.chemAppId}-delete`}
                data-position="top" data-tooltip="Delete">
                <i className="material-icons">clear</i>
              </a>
            </li>
          : ''
        }

      </ul>
      <div>
        { // eslint-disable-next-line
          CultivationModal(ChemicalApplicationDisplay)
          // eslint-disable-next-line
          ({ id: `${chem.chemAppId}-view`,
             footer: true,
             view: true,
             toDelete: false,
             chemicalList,
             employees,
             solutions: chem.solutions,
             application: chem,
             selectApplicationToView,
             selectedApp
           })
        }
        {
          CultivationModal(ChemicalApplicationDisplay)
          // eslint-disable-next-line
          ({ id: `${chem.chemAppId}-delete`,
            footer: true,
            view: false,
            toDelete: true,
            chemicalList,
            employees,
            solutions: chem.solutions,
            application: chem,
            previousApplications: [],
            onClick: () => deleteChemicalApplication(chem)
          })
        }
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    employees: state.cultivation.utils.employees,
    user: state.auth.user
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    deleteChemicalApplication
  }, dispatch);
}



FabModal.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(FabModal);




/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/fab_modal.js